import { jsPDF } from "jspdf";

export const generatePDF = (
  practice_id,
  practice,
  practice_object,
  adminNotes,
  pdfSend,
) => {
  const doc = new jsPDF();
  const pageHeight = doc.internal.pageSize.height; // Usa l'altezza effettiva della pagina

  doc.setFontSize(16); // Font per il titolo
  doc.text(`Riepilogo pratica #${practice_id}`, 10, 10);

  let y = 20;
  const lineHeight = 8;
  // const pageHeight = 380;
  const bottomMargin = 40;

  /**
   * Aggiunge una riga al PDF con font fisso di 14px.
   * @param {string} label - Testo della chiave (label).
   * @param {string} value - Valore associato alla chiave.
   */

  // step 1

  const addLine = (label, value) => {
    const maxLabelWidth = 95;
    const maxValueWidth = 80;

    // Spezza label
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    const labelLines = doc.splitTextToSize(label + ":", maxLabelWidth);

    // Spezza value
    doc.setFont("helvetica", "normal");
    const valueLines = doc.splitTextToSize(value || "", maxValueWidth);

    // Calcola row
    const numLines = Math.max(labelLines.length, valueLines.length);
    const blockHeight = numLines * lineHeight;

    // Controllo pagina
    if (y + blockHeight + bottomMargin > pageHeight) {
      doc.addPage();
      y = 10;
    }

    // Stampa LABEL
    doc.setFont("helvetica", "bold");
    doc.text(labelLines, 10, y);

    // Stampa VALUE
    doc.setFont("helvetica", "normal");
    doc.text(valueLines, 120, y);

    y += blockHeight;
  };

  doc.setTextColor(188, 41, 87);
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text("Step 1 - Incarico", 10, y);

  y += lineHeight * 0.5;

  doc.setTextColor(0, 0, 0);
  doc.setDrawColor(169, 169, 169);
  doc.setLineWidth(0.5);
  doc.line(10, y, 200, y);

  y += lineHeight;

  // step 1

  addLine("Nome della pratica", practice?.Incarico?.Nome_pratica || "");

  addLine(
    "Dipartimento Elibra",
    practice?.Incarico?.Team_riferimento?.name || "",
  );
  addLine(
    "Prodotto richiesto",
    practice?.Incarico?.Prodotto_richiesto?.name || "",
  );
  addLine(
    "Valore associato alla pratica",
    practice?.Incarico?.valore_associato_pratica || "",
  );
  addLine(
    "Responsabile della pratica",
    practice?.Incarico?.responsabile_pratica || "",
  );
  addLine("Source of business (SOB)", practice?.Incarico?.SOB || "");

  // step 2
  y += lineHeight * 1;

  doc.setTextColor(188, 41, 87);
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text("Step 2 - Cliente", 10, y);

  y += lineHeight * 0.5;

  doc.setTextColor(0, 0, 0);
  doc.setDrawColor(169, 169, 169);
  doc.setLineWidth(0.5);
  doc.line(10, y, 200, y);

  y += lineHeight;

  // step 2

  addLine("Status", practice?.cliente?.status || "");
  addLine("Tipologia", practice?.cliente?.tipologia || "");

  if (practice?.cliente?.segmento_operatività) {
    addLine(
      "Segmento di operatività",
      practice?.cliente?.segmento_operatività || "",
    );
  }

  if (practice?.cliente.lingua_corrispondenza) {
    addLine(
      "Lingua di corrispondenza",
      practice?.cliente?.lingua_corrispondenza || "",
    );
  }

  if (practice?.cliente?.tipologia === "Persona fisica italiana") {
    addLine("Nome", practice?.cliente?.nome || "");
    addLine("Cognome", practice?.cliente?.cognome || "");

    if (practice?.cliente?.status === "Nuovo cliente") {
      if (practice?.cliente?.codice_fiscale) {
        addLine(
          "Partita IVA o Codice fiscale",
          practice.cliente.codice_fiscale,
        );
      }
      if (practice?.cliente?.comune) {
        addLine("Comune", practice.cliente.comune);
      }
      if (practice?.cliente?.indirizzo) {
        addLine("Indirizzo e Civico", practice.cliente.indirizzo);
      }
      if (practice?.cliente?.CAP) {
        addLine("CAP", practice.cliente.CAP);
      }
      if (practice?.cliente?.SDI) {
        addLine("SDI", practice.cliente.SDI);
      }

      if (
        practice?.cliente?.cliente_affiliato_gruppo_societari &&
        practice?.cliente?.cliente_affiliato_gruppo_societari === "Sì"
      ) {
        addLine(
          "Il Cliente è affiliato a gruppi societari",
          practice?.cliente?.cliente_affiliato_gruppo_societari,
        );
      }

      if (practice?.cliente?.cliente_collegamento_societa) {
        addLine(
          "Società/gruppo con cui il cliente è collegato",
          practice?.cliente?.cliente_collegamento_societa,
        );
      }

      if (practice?.cliente?.cliente_ruolo) {
        addLine("Ruolo", practice?.cliente?.cliente_ruolo);
      }

      if (practice?.cliente?.cliente_altro) {
        addLine("Altro", practice?.cliente?.cliente_altro);
      }

      if (practice?.cliente?.email_principale) {
        addLine(
          "E-mail di contatto principale",
          practice.cliente.email_principale,
        );
      }

      if (practice?.cliente?.contatto_principale_CRM) {
        addLine(
          "Contatto da aggiungere al CRM",
          practice.cliente.contatto_principale_CRM,
        );
      }

      if (practice?.cliente?.email_fatture) {
        addLine(
          "E-mail di destinazione delle fatture",
          practice.cliente.email_fatture,
        );
      }
      if (
        practice?.cliente?.altri_contatti === "Sì" &&
        practice?.cliente?.contatti
      ) {
        addLine("Altri contatti", practice.cliente.contatti);
      }

      if (practice?.cliente?.cliente_partnership) {
        addLine(
          "Il Cliente è segnalato sulla base di una partnership con LEXIA",
          practice?.cliente?.cliente_partnership,
        );
      }

      if (
        practice?.cliente?.cliente_partnership === "Sì" &&
        practice?.cliente?.accordo_cliente_partner
      ) {
        addLine(
          "Accordo sottostante",
          practice.cliente.accordo_cliente_partner,
        );
      }
    }

    if (practice?.cliente?.cliente_provenienza) {
      addLine(
        "Il cliente proviene da un'altra area LEXIA (crossselling)",
        practice?.cliente?.cliente_provenienza,
      );
    }

    if (
      practice?.cliente?.cliente_provenienza === "Sì" &&
      practice?.cliente?.cliente_provenienza
    ) {
      addLine("Area", practice?.cliente?.cliente_area_provenienza);
    }
  }

  if (practice?.cliente?.tipologia === "Persona fisica altro paese UE") {
    if (practice?.cliente?.nome) {
      addLine("Nome", practice.cliente.nome);
    }
    if (practice?.cliente?.cognome) {
      addLine("Cognome", practice.cliente.cognome);
    }

    if (practice?.cliente?.status === "Nuovo cliente") {
      if (practice?.cliente?.codice_fiscale) {
        addLine("VAT number o Fiscal code", practice.cliente.codice_fiscale);
      }
      if (practice?.cliente?.comune) {
        addLine("Comune", practice.cliente.comune);
      }
      if (practice?.cliente?.indirizzo) {
        addLine("Indirizzo e Civico", practice.cliente.indirizzo);
      }
      if (practice?.cliente?.CAP) {
        addLine("CAP", practice.cliente.CAP);
      }
      if (practice?.cliente?.SDI) {
        addLine("SDI", practice.cliente.SDI);
      }

      if (
        practice?.cliente?.cliente_affiliato_gruppo_societari &&
        practice?.cliente?.cliente_affiliato_gruppo_societari === "Sì"
      ) {
        addLine(
          "Il Cliente è affiliato a gruppi societari",
          practice?.cliente?.cliente_affiliato_gruppo_societari,
        );
      }

      if (practice?.cliente?.cliente_collegamento_societa) {
        addLine(
          "Società/gruppo con cui il cliente è collegato",
          practice?.cliente?.cliente_collegamento_societa,
        );
      }

      if (practice?.cliente?.cliente_ruolo) {
        addLine("Ruolo", practice?.cliente?.cliente_ruolo);
      }

      if (practice?.cliente?.cliente_altro) {
        addLine("Altro", practice?.cliente?.cliente_altro);
      }

      if (practice?.cliente?.email_principale) {
        addLine(
          "E-mail di contatto principale",
          practice.cliente.email_principale,
        );
      }

      if (practice?.cliente?.contatto_principale_CRM) {
        addLine(
          "Contatto da aggiungere al CRM",
          practice.cliente.contatto_principale_CRM,
        );
      }

      if (practice?.cliente?.email_fatture) {
        addLine(
          "E-mail di destinazione delle fatture",
          practice.cliente.email_fatture,
        );
      }
      if (
        practice?.cliente?.altri_contatti === "Sì" &&
        practice?.cliente?.contatti
      ) {
        addLine("Altri contatti", practice.cliente.contatti);
      }

      if (practice?.cliente?.cliente_partnership) {
        addLine(
          "Il Cliente è segnalato sulla base di una partnership con LEXIA",
          practice?.cliente?.cliente_partnership,
        );
      }

      if (
        practice?.cliente?.cliente_partnership === "Sì" &&
        practice?.cliente?.accordo_cliente_partner
      ) {
        addLine(
          "Accordo sottostante",
          practice.cliente.accordo_cliente_partner,
        );
      }
    }

    if (practice?.cliente?.cliente_provenienza) {
      addLine(
        "Il cliente proviene da un'altra area LEXIA (crossselling)",
        practice?.cliente?.cliente_provenienza,
      );
    }

    if (
      practice?.cliente?.cliente_provenienza === "Sì" &&
      practice?.cliente?.cliente_provenienza
    ) {
      addLine("Area", practice?.cliente?.cliente_area_provenienza);
    }
  }

  if (practice?.cliente?.tipologia === "Persona fisica extra UE") {
    if (practice?.cliente?.nome) {
      addLine("Nome", practice.cliente.nome);
    }
    if (practice?.cliente?.cognome) {
      addLine("Cognome", practice.cliente.cognome);
    }

    if (practice?.cliente?.status === "Nuovo cliente") {
      if (practice?.cliente?.codice_fiscale) {
        addLine("VAT number o Fiscal code", practice.cliente.codice_fiscale);
      }
      if (practice?.cliente?.comune) {
        addLine("Comune", practice.cliente.comune);
      }
      if (practice?.cliente?.indirizzo) {
        addLine("Indirizzo e Civico", practice.cliente.indirizzo);
      }
      if (practice?.cliente?.CAP) {
        addLine("CAP", practice.cliente.CAP);
      }
      if (practice?.cliente?.SDI) {
        addLine("SDI", practice.cliente.SDI);
      }

      if (
        practice?.cliente?.cliente_affiliato_gruppo_societari &&
        practice?.cliente?.cliente_affiliato_gruppo_societari === "Sì"
      ) {
        addLine(
          "Il Cliente è affiliato a gruppi societari",
          practice?.cliente?.cliente_affiliato_gruppo_societari,
        );
      }

      if (practice?.cliente?.cliente_collegamento_societa) {
        addLine(
          "Società/gruppo con cui il cliente è collegato",
          practice?.cliente?.cliente_collegamento_societa,
        );
      }

      if (practice?.cliente?.cliente_ruolo) {
        addLine("Ruolo", practice?.cliente?.cliente_ruolo);
      }

      if (practice?.cliente?.cliente_altro) {
        addLine("Altro", practice?.cliente?.cliente_altro);
      }

      if (practice?.cliente?.email_principale) {
        addLine(
          "E-mail di contatto principale",
          practice.cliente.email_principale,
        );
      }

      if (practice?.cliente?.contatto_principale_CRM) {
        addLine(
          "Contatto da aggiungere al CRM",
          practice.cliente.contatto_principale_CRM,
        );
      }

      if (practice?.cliente?.email_fatture) {
        addLine(
          "E-mail di destinazione delle fatture",
          practice.cliente.email_fatture,
        );
      }
      if (
        practice?.cliente?.altri_contatti === "Sì" &&
        practice?.cliente?.contatti
      ) {
        addLine("Altri contatti", practice.cliente.contatti);
      }

      if (practice?.cliente?.cliente_partnership) {
        addLine(
          "Il Cliente è segnalato sulla base di una partnership con LEXIA",
          practice?.cliente?.cliente_partnership,
        );
      }

      if (
        practice?.cliente?.cliente_partnership === "Sì" &&
        practice?.cliente?.accordo_cliente_partner
      ) {
        addLine(
          "Accordo sottostante",
          practice.cliente.accordo_cliente_partner,
        );
      }
    }

    if (practice?.cliente?.cliente_provenienza) {
      addLine(
        "Il cliente proviene da un'altra area LEXIA (crossselling)",
        practice?.cliente?.cliente_provenienza,
      );
    }

    if (
      practice?.cliente?.cliente_provenienza === "Sì" &&
      practice?.cliente?.cliente_provenienza
    ) {
      addLine("Area", practice?.cliente?.cliente_area_provenienza);
    }
  }

  if (practice?.cliente?.tipologia === "Persona giuridica italiana") {
    if (practice?.cliente?.denominazione_sociale) {
      addLine("Denominazione sociale", practice.cliente.denominazione_sociale);
    }

    if (practice?.cliente?.status === "Nuovo cliente") {
      if (practice?.cliente?.partita_iva) {
        addLine("Partita IVA o Codice fiscale", practice.cliente.partita_iva);
      }
      if (practice?.cliente?.comune) {
        addLine("Comune", practice.cliente.comune);
      }
      if (practice?.cliente?.indirizzo) {
        addLine("Indirizzo e Civico", practice.cliente.indirizzo);
      }
      if (practice?.cliente?.CAP) {
        addLine("CAP", practice.cliente.CAP);
      }
      if (practice?.cliente?.SDI) {
        addLine("Codice SDI o PEC", practice.cliente.SDI);
      }

      if (
        practice?.cliente?.appartiene_gruppo_societario &&
        practice?.cliente?.appartiene_gruppo_societario === "Sì"
      ) {
        addLine(
          "Il cliente appartiene a un gruppo societario",
          practice?.cliente?.appartiene_gruppo_societario,
        );
      }

      if (practice?.cliente?.denominazione_gruppo_holding) {
        addLine(
          "Denominazione del gruppo/holding",
          practice?.cliente?.denominazione_gruppo_holding,
        );
      }

      if (practice?.cliente?.capogruppo) {
        addLine(
          "Capogruppo (società controllante)",
          practice?.cliente?.capogruppo,
        );
      }

      if (practice?.cliente?.relazione_cliente_gruppo) {
        addLine(
          "Ruolo/relazione del cliente nel gruppo",
          practice?.cliente?.relazione_cliente_gruppo,
        );
      }

      if (practice?.cliente?.gruppo_societa_rilevante) {
        addLine(
          "Società del gruppo rilevanti ai fini del mandato",
          practice?.cliente?.gruppo_societa_rilevante,
        );
      }

      if (practice?.cliente?.altre_controparti) {
        addLine("Altro", practice?.cliente?.altre_controparti);
      }

      if (practice?.cliente?.email_principale) {
        addLine(
          "E-mail di contatto principale",
          practice.cliente.email_principale,
        );
      }

      if (practice?.cliente?.contatto_principale_CRM) {
        addLine(
          "Contatto da aggiungere al CRM",
          practice.cliente.contatto_principale_CRM,
        );
      }

      if (practice?.cliente?.email_fatture) {
        addLine(
          "E-mail di destinazione delle fatture",
          practice.cliente.email_fatture,
        );
      }
      if (
        practice?.cliente?.altri_contatti === "Sì" &&
        practice?.cliente?.contatti
      ) {
        addLine("Altri contatti", practice.cliente.contatti);
      }

      if (practice?.cliente?.cliente_partnership) {
        addLine(
          "Il Cliente è segnalato sulla base di una partnership con LEXIA",
          practice?.cliente?.cliente_partnership,
        );
      }

      if (
        practice?.cliente?.cliente_partnership === "Sì" &&
        practice?.cliente?.accordo_cliente_partner
      ) {
        addLine(
          "Accordo sottostante",
          practice.cliente.accordo_cliente_partner,
        );
      }
    }

    if (practice?.cliente?.cliente_provenienza) {
      addLine(
        "Il cliente proviene da un'altra area LEXIA (crossselling)",
        practice?.cliente?.cliente_provenienza,
      );
    }

    if (
      practice?.cliente?.cliente_provenienza === "Sì" &&
      practice?.cliente?.cliente_provenienza
    ) {
      addLine("Area", practice?.cliente?.cliente_area_provenienza);
    }
  }

  if (practice?.cliente?.tipologia === "Persona giuridica altro paese UE") {
    if (practice?.cliente?.denominazione_sociale) {
      addLine("Denominazione sociale", practice.cliente.denominazione_sociale);
    }

    if (practice?.cliente?.status === "Nuovo cliente") {
      if (practice?.cliente?.partita_iva) {
        addLine("VAT number", practice.cliente.partita_iva);
      }
      if (practice?.cliente?.comune) {
        addLine("Comune", practice.cliente.comune);
      }
      if (practice?.cliente?.indirizzo) {
        addLine("Indirizzo e Civico", practice.cliente.indirizzo);
      }
      if (practice?.cliente?.CAP) {
        addLine("CAP", practice.cliente.CAP);
      }
      if (practice?.cliente?.SDI) {
        addLine("Codice SDI o PEC", practice.cliente.SDI);
      }

      if (
        practice?.cliente?.appartiene_gruppo_societario &&
        practice?.cliente?.appartiene_gruppo_societario === "Sì"
      ) {
        addLine(
          "Il cliente appartiene a un gruppo societario",
          practice?.cliente?.appartiene_gruppo_societario,
        );
      }

      if (practice?.cliente?.denominazione_gruppo_holding) {
        addLine(
          "Denominazione del gruppo/holding",
          practice?.cliente?.denominazione_gruppo_holding,
        );
      }

      if (practice?.cliente?.capogruppo) {
        addLine(
          "Capogruppo (società controllante)",
          practice?.cliente?.capogruppo,
        );
      }

      if (practice?.cliente?.relazione_cliente_gruppo) {
        addLine(
          "Ruolo/relazione del cliente nel gruppo",
          practice?.cliente?.relazione_cliente_gruppo,
        );
      }

      if (practice?.cliente?.gruppo_societa_rilevante) {
        addLine(
          "Società del gruppo rilevanti ai fini del mandato",
          practice?.cliente?.gruppo_societa_rilevante,
        );
      }

      if (practice?.cliente?.altre_controparti) {
        addLine("Altro", practice?.cliente?.altre_controparti);
      }

      if (practice?.cliente?.email_principale) {
        addLine(
          "E-mail di contatto principale",
          practice.cliente.email_principale,
        );
      }

      if (practice?.cliente?.contatto_principale_CRM) {
        addLine(
          "Contatto da aggiungere al CRM",
          practice.cliente.contatto_principale_CRM,
        );
      }

      if (practice?.cliente?.email_fatture) {
        addLine(
          "E-mail di destinazione delle fatture",
          practice.cliente.email_fatture,
        );
      }
      if (
        practice?.cliente?.altri_contatti === "Sì" &&
        practice?.cliente?.contatti
      ) {
        addLine("Altri contatti", practice.cliente.contatti);
      }

      if (practice?.cliente?.cliente_partnership) {
        addLine(
          "Il Cliente è segnalato sulla base di una partnership con LEXIA",
          practice?.cliente?.cliente_partnership,
        );
      }

      if (
        practice?.cliente?.cliente_partnership === "Sì" &&
        practice?.cliente?.accordo_cliente_partner
      ) {
        addLine(
          "Accordo sottostante",
          practice.cliente.accordo_cliente_partner,
        );
      }
    }

    if (practice?.cliente?.cliente_provenienza) {
      addLine(
        "Il cliente proviene da un'altra area LEXIA (crossselling)",
        practice?.cliente?.cliente_provenienza,
      );
    }

    if (
      practice?.cliente?.cliente_provenienza === "Sì" &&
      practice?.cliente?.cliente_provenienza
    ) {
      addLine("Area", practice?.cliente?.cliente_area_provenienza);
    }
  }

  if (practice?.cliente?.tipologia === "Persona giuridica extra UE") {
    if (practice?.cliente?.denominazione_sociale) {
      addLine("Denominazione sociale", practice.cliente.denominazione_sociale);
    }

    if (practice?.cliente?.status === "Nuovo cliente") {
      if (practice?.cliente?.partita_iva) {
        addLine("VAT number", practice.cliente.partita_iva);
      }
      if (practice?.cliente?.comune) {
        addLine("Comune", practice.cliente.comune);
      }
      if (practice?.cliente?.indirizzo) {
        addLine("Indirizzo e Civico", practice.cliente.indirizzo);
      }
      if (practice?.cliente?.CAP) {
        addLine("CAP", practice.cliente.CAP);
      }

      if (
        practice?.cliente?.appartiene_gruppo_societario &&
        practice?.cliente?.appartiene_gruppo_societario === "Sì"
      ) {
        addLine(
          "Il cliente appartiene a un gruppo societario",
          practice?.cliente?.appartiene_gruppo_societario,
        );
      }

      if (practice?.cliente?.denominazione_gruppo_holding) {
        addLine(
          "Denominazione del gruppo/holding",
          practice?.cliente?.denominazione_gruppo_holding,
        );
      }

      if (practice?.cliente?.capogruppo) {
        addLine(
          "Capogruppo (società controllante)",
          practice?.cliente?.capogruppo,
        );
      }

      if (practice?.cliente?.relazione_cliente_gruppo) {
        addLine(
          "Ruolo/relazione del cliente nel gruppo",
          practice?.cliente?.relazione_cliente_gruppo,
        );
      }

      if (practice?.cliente?.gruppo_societa_rilevante) {
        addLine(
          "Società del gruppo rilevanti ai fini del mandato",
          practice?.cliente?.gruppo_societa_rilevante,
        );
      }

      if (practice?.cliente?.altre_controparti) {
        addLine("Altro", practice?.cliente?.altre_controparti);
      }

      if (practice?.cliente?.email_principale) {
        addLine(
          "E-mail di contatto principale",
          practice.cliente.email_principale,
        );
      }

      if (practice?.cliente?.contatto_principale_CRM) {
        addLine(
          "Contatto da aggiungere al CRM",
          practice.cliente.contatto_principale_CRM,
        );
      }

      if (practice?.cliente?.email_fatture) {
        addLine(
          "E-mail di destinazione delle fatture",
          practice.cliente.email_fatture,
        );
      }
      if (
        practice?.cliente?.altri_contatti === "Sì" &&
        practice?.cliente?.contatti
      ) {
        addLine("Altri contatti", practice.cliente.contatti);
      }

      if (practice?.cliente?.cliente_partnership) {
        addLine(
          "Il Cliente è segnalato sulla base di una partnership con LEXIA",
          practice?.cliente?.cliente_partnership,
        );
      }

      if (
        practice?.cliente?.cliente_partnership === "Sì" &&
        practice?.cliente?.accordo_cliente_partner
      ) {
        addLine(
          "Accordo sottostante",
          practice.cliente.accordo_cliente_partner,
        );
      }
    }

    if (practice?.cliente?.cliente_provenienza) {
      addLine(
        "Il cliente proviene da un'altra area LEXIA (crossselling)",
        practice?.cliente?.cliente_provenienza,
      );
    }

    if (
      practice?.cliente?.cliente_provenienza === "Sì" &&
      practice?.cliente?.cliente_provenienza
    ) {
      addLine("Area", practice?.cliente?.cliente_area_provenienza);
    }
  }

  // step 3
  y += lineHeight * 1;

  doc.setTextColor(188, 41, 87);
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text("Step 3 - Compenso", 10, y);

  y += lineHeight * 0.5;

  doc.setTextColor(0, 0, 0);
  doc.setDrawColor(169, 169, 169);
  doc.setLineWidth(0.5);
  doc.line(10, y, 200, y);

  y += lineHeight;

  // step 3

  addLine(
    "Oggetto della pro-forma / fattura",
    practice?.compenso?.pro_forma_fattura || "",
  );
  addLine("Modalità di compenso", practice?.compenso?.modalità_compenso || "");

  if (practice?.compenso?.modalità_compenso === "Forfait") {
    addLine(
      "Compenso complessivo",
      practice?.compenso?.compenso_complessivo || "",
    );

    addLine(
      "Dettagli della fatturazione del compenso",
      practice?.compenso?.dettagli_fatturazione_compenso || "",
    );

    addLine(
      "Periodo di competenza",
      `Dal ${practice?.compenso?.periodo_competenza_inizio || ""} Al ${practice?.compenso?.periodo_competenza_fine || ""
      }`,
    );
  }

  if (practice?.compenso?.modalità_compenso === "Listino/Tariffa oraria") {
    addLine(
      "Riferimento per il calcolo",
      practice?.compenso?.riferimento_calcolo || "",
    );

    if (practice?.compenso?.riferimento_calcolo === "Listino personalizzato") {
      addLine("Tariffa specifica", practice?.compenso?.tariffa_specifica || "");
    }

    if (practice?.compenso?.note_compenso_listino_tariffa_oraria) {
      addLine(
        "Note sul compenso o Cap",
        practice?.compenso?.note_compenso_listino_tariffa_oraria || "",
      );
    }
  }

  if (practice?.compenso?.modalità_compenso === "Mista") {
    if (practice?.compenso?.tariffa_oraria) {
      addLine("Tariffa oraria", practice?.compenso?.tariffa_oraria || "");
    }

    if (practice?.compenso?.tariffa_oraria === "Listino personalizzato") {
      addLine("Tariffa specifica", practice?.compenso?.tariffa_specifica || "");
    }

    if (practice?.compenso?.compenso_combinazione_forfait_listino) {
      const title =
        "Dettagli del compenso a forfait e della sua combinazione con il listino selezionato";
      const maxWidthTitle = 100;
      const splitTitle = doc.splitTextToSize(title, maxWidthTitle);

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text(splitTitle, 10, y);

      const titleHeight = lineHeight * splitTitle.length;

      doc.setFont("helvetica", "normal");
      const maxWidth = 80;
      const splitValue = doc.splitTextToSize(
        practice?.compenso?.compenso_combinazione_forfait_listino || "",
        maxWidth,
      );

      doc.text(splitValue, 120, y);

      y += Math.max(titleHeight, lineHeight * splitValue.length);
    }
  }

  addLine(
    "Percentuale di spese generali da applicare",
    practice?.compenso?.percentuale_spese || "",
  );

  if (practice?.compenso?.percentuale_spese === "Altra percentuale") {
    addLine(
      "Percentuale specifica",
      practice?.compenso?.percentuale_spese_specifica
        ? `${practice?.compenso?.percentuale_spese_specifica}%`
        : "",
    );
  }

  addLine(
    "Compenso ripartito con altri team",
    practice?.compenso?.compenso_condiviso || "",
  );

  if (practice?.compenso?.compenso_condiviso === "Sì") {
    addLine(
      "Compenso ripartito con il team",
      practice?.compenso?.team_compenso_condiviso
        ?.map((team) => team.name)
        .join(" - ") || "Nessun team selezionato",
    );

    addLine(
      "Dettagli della ripartizione",
      practice?.compenso?.dettagli_divisione || "",
    );
  }

  addLine(
    "Condizioni di pagamento",
    practice?.compenso?.condizioni_pagamento || "",
  );

  addLine(
    "Compensi a soggetti in outsourcing",
    practice?.compenso?.compensi_outsourcing || "",
  );

  if (practice?.compenso?.compensi_outsourcing === "Sì") {
    addLine(
      "Dettagli dei compensi per outsourcing",
      practice?.compenso?.dettagli_compensi_outsourcing || "",
    );
  }

  // step 4
  y += lineHeight * 1;

  doc.setTextColor(188, 41, 87);
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text("Step 4 - AML", 10, y);

  y += lineHeight * 0.5;

  doc.setTextColor(0, 0, 0);
  doc.setDrawColor(169, 169, 169);
  doc.setLineWidth(0.5);
  doc.line(10, y, 200, y);

  y += lineHeight;

  // step 4

  addLine("Controlli AML", practice?.AML?.controlli_AML || "");

  if (practice?.AML?.controlli_AML === "Sì") {
    addLine("Tipologia di verifica", practice?.AML?.tipologia_verifica || "");

    addLine("Livello di rischio", practice?.AML?.livello_rischio || "");
  }

  // step 5

  if (practice_object) {
    y += lineHeight * 1;

    doc.setTextColor(188, 41, 87);
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("Note dell'amministrazione", 10, y);

    y += lineHeight * 0.5;

    doc.setTextColor(0, 0, 0);
    doc.setDrawColor(169, 169, 169);
    doc.setLineWidth(0.5);
    doc.line(10, y, 200, y);

    y += lineHeight;
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0, 0, 0);

    const noteAdmin = practice_object.note_admin?.trim();
    const notesText =
      noteAdmin && noteAdmin.toLowerCase() !== "undefined"
        ? noteAdmin
        : "Nessuna nota";

    doc.text(notesText, 10, y);

    y += lineHeight;
  }

  if (pdfSend) {
    const pdfBlob = doc.output("blob");
    return pdfBlob;
  } else {
    doc.save(`Riepilogo_pratica_${practice_id}.pdf`);
  }
};
